import React from 'react';

import { Footer as OfferFooter } from 'offer/components/footer';

// Footer slot for Staff Quote Revisit. Renders today's footer until #36376 replaces it, so the
// page can still update the quote and go to checkout while the lanes build.
const Footer = (props) => <OfferFooter {...props} />;

export default Footer;
